/* =============================================================
   infoModal.js
   Classe per la modale INFORMATIVA #infoModal (Controls/Modals/MDLInfo.ascx).
   Sola lettura, centrata, senza loader, senza bottoni di azione (solo chiusura).
   Helper drop-in: Info_Show(titolo, contenuto).
   Si auto-registra su application.ModalManagerIstance quando l'app e' pronta
   (stesso pattern di eventModal/objectModal) -> NON tocca app.js ne' i bundle.
   FV - 2026-06-10 - creazione (tipologia "informativa" del catalogo modali)
   ============================================================= */
class InfoModal {

    Id = null;
    _element = null;

    constructor(selector) {
        this.Id = selector;
        this._element = document.getElementById(selector);
    }

    /**
     * Apre la modale informativa.
     * @param {Object} o
     * @param {string} o.title               Titolo header (HTML ammesso)
     * @param {string|HTMLElement} o.content  HTML o nodo da iniettare nel body
     */
    open(o) {
        o = o || {};
        try {
            this._element.querySelector('#infoModalLabel').innerHTML = o.title || '';
            const body = this._element.querySelector('#infoModalBody');
            body.innerHTML = '';
            if (o.content instanceof HTMLElement) {
                body.appendChild(o.content);
            } else {
                body.innerHTML = o.content || '';
            }
            application.ModalManagerIstance.show(this.Id);
        } catch (e) {
            console.error('[infoModal] open', e);
        }
    }

    close() {
        application.ModalManagerIstance.hide(this.Id);
    }
}

/* Helper globale per mostrare contenuto informativo in modale.
   Esempio: Info_Show('Informazioni aggiuntive', this.dataset.info); */
function Info_Show(title, htmlContent) {
    if (window.application && application.InfoModalIstance) {
        application.InfoModalIstance.open({ title: title, content: htmlContent });
    } else {
        console.warn('[infoModal] application.InfoModalIstance non ancora pronta');
    }
}

/* Auto-registrazione: stessa logica di eventModal/objectModal, senza toccare app.js. */
(function () {
    function initInfoModal() {
        if (typeof application === 'undefined' || !application || !application.ModalManagerIstance) return false;
        if (!document.getElementById('infoModal')) return false;
        if (application.InfoModalIstance) return true; // gia' registrata
        application.InfoModalIstance = new InfoModal('infoModal');
        application.ModalManagerIstance.register('infoModal', null, null);
        return true;
    }
    document.addEventListener('appBuilt', initInfoModal);
    document.addEventListener('DOMContentLoaded', function () {
        if (!initInfoModal()) { setTimeout(initInfoModal, 600); }
    });
})();
